export default __webpack_public_path__ + "static/media/Note_Icon.bd2e4771.svg";